import AxiosService from './AxiosService'

class RootCertificateRestService {
    static getCertificateDetails(): Promise<any> {
        return AxiosService.get('/settings/rootcert')
    }

    static getCertificate(): Promise<any> {
        return AxiosService.get('/settings/rootcert/download', { responseType: 'blob' })
    }
}

export default RootCertificateRestService